export const PROPOSAL_PENDING = 'pending';
export const PROPOSAL_AFIRMATIVE = 'affirmative';
export const PROPOSAL_NEGATIVE = 'negative';
